import { MapPin, ShieldCheck, Sparkles, Bot, Receipt, Headphones } from "lucide-react";

const features = [
  { icon: MapPin, title: "GPS Tracked Vehicles", desc: "Real-time vehicle location visible on your corporate dashboard." },
  { icon: ShieldCheck, title: "Police Verified Drivers", desc: "Every driver is background-checked and police verified." },
  { icon: Sparkles, title: "Quality Fleet", desc: "Vehicles are quality-checked regularly — sedans, 6-seaters, Innova Crysta." },
  { icon: Bot, title: "Zero Human Dependency", desc: "Fully automated scheduling — no calls, no coordination headaches." },
  { icon: Receipt, title: "Transparent Billing", desc: "Automated trip billing with GST-compliant invoices — 15-day payment cycle." },
  { icon: Headphones, title: "24/7 Customer Support", desc: "Round-the-clock support for companies and employees." },
];

export default function WhyChoose() {
  return (
    <section className="section-pad bg-white" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-14 reveal">
          <div className="eyebrow mb-4">Why Choose Rydey</div>
          <h2 className="headline text-[34px] md:text-[44px]">
            Reliability isn't a promise — it's our operating system.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-0 border border-slate-200 rounded-2xl overflow-hidden">
          {features.map((f, i) => (
            <FeatureCell key={f.title} {...f} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCell({ icon: Icon, title, desc, index }) {
  // Add right and bottom borders to create grid lines
  const colMod = index % 3;
  const isLastRowOnLg = index >= 3;
  return (
    <div
      data-testid={`why-feature-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`group relative p-8 bg-white hover:bg-[#0D1B40] transition-colors duration-300 reveal ${
        colMod !== 2 ? "lg:border-r border-slate-200" : ""
      } ${index % 2 !== 1 ? "md:border-r" : "md:border-r-0"} md:border-r-slate-200 ${
        !isLastRowOnLg ? "lg:border-b border-slate-200" : ""
      } ${index < features.length - 2 ? "border-b border-slate-200 md:border-b" : ""}`}
      style={{ transitionDelay: `${index * 0.05}s` }}
    >
      <div className="w-12 h-12 rounded-lg bg-[#F5A623]/15 text-[#F5A623] flex items-center justify-center mb-5 group-hover:bg-[#F5A623] group-hover:text-[#0D1B40] transition-colors">
        <Icon size={22} />
      </div>
      <h3 className="font-bold text-[18px] text-[#0D1B40] group-hover:text-white transition-colors">
        {title}
      </h3>
      <p className="mt-2.5 text-[14.5px] leading-relaxed text-slate-600 group-hover:text-white/75 transition-colors">
        {desc}
      </p>
    </div>
  );
}
